<!--suppress ALL -->
<script lang="ts">
import {transaksiTypes} from '../../../util/PluralVariabels';
  import {Component, Vue, Prop} from 'annotation';
  import {cloneArray} from "../../../util/Underscore";

  import GField from '../common/field/GField.vue';
  import GSelect from '../common/select/GSelect.vue';

  @Component
  export default class TransaksiTypeSelect extends Vue {

    @Prop({default: transaksiTypes[0].value, type: String})
    public transaksiType: string;

    @Prop({default: false, type: Boolean})
    public skipLabel: boolean;

    @Prop({default: true, type: Boolean})
    public isFullwidth: boolean;

    @Prop({type: String, default: null})
    public type: any;

    @Prop({type: String, default: null})
    public message: any;

    @Prop({type: Boolean, default: false})
    public disabled: any;

    public onSelectTransaksiType(param: string) {
      this.$emit('update:transaksiType', param || transaksiTypes[0].value);
      this.$emit('selected', param);
    }

    public render(createElement: Function) {
      const {$t, transaksiType, isFullwidth, message, type} = this;

      const mainAttr: any = {
        props: {
          value: transaksiType,
          isFullwidth, placeholder: `${$t('label.choose')} ${$t('label.transaksi_type')}`
        },
        attrs: {disabled: this.disabled},
        on: {change: this.onSelectTransaksiType}
      };

      const main: any = createElement(GSelect, mainAttr, cloneArray(transaksiTypes).map((item: any) => {
        const option: any = {key: item.value, attrs: {value: item.value}};

        return createElement('option', option, item.label);
      }));

      if (this.skipLabel) {
        return main;
      }

      return createElement(GField, {props: {label: $t('label.transaksi_type'), message, type}}, [main]);
    }
  }
</script>
